import { Button } from '@mantine/core';
import { Locked } from '@carbon/icons-react';
import { defineMessages, useIntl } from 'react-intl';
import { useState } from 'react';

import CommonStyles from '../CommonStyles.module.scss';

import PasswordChangeModal from 'Screens/Dashboard/Settings/Options/PasswordChangeButton/PasswordChangeModal/PasswordChangeModal';

const PasswordChangeButton = () => {
    const intl = useIntl();
    const [modalOpen, setModalOpen] = useState(false);

    const onPasswordChangeRequest = () => {
        setModalOpen(true);
    };

    return (
        <>
            <Button
                className={CommonStyles.button}
                variant="light"
                leftSection={<Locked size={16} />}
                onClick={onPasswordChangeRequest}
            >
                {intl.formatMessage(messages.changePassword)}
            </Button>
            <PasswordChangeModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
        </>
    );
};

const messages = defineMessages({
    changePassword: {
        id: 'src.Screens.Dashboard.Settings.SettingsTabs.changePassword',
        defaultMessage: 'Zmień hasło',
    },
});

export default PasswordChangeButton;
